import { CSVLink } from 'react-csv';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { theme } from 'styled';
import { useObjectState } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    Container,
    DownloadBox,
    FilterBox,
    FooterContainer,
    Input,
    List,
    Search
} from './styled';
import {
    DownloadList,
    ExternalLoginModal
} from 'views/components';
import {
    Dropdown,
    IconButton,
    Loader,
    MaterialIcon
} from 'mol-ui';
import React, { useState } from 'react';
const { textColor } = theme;

const ListingLayout = ({
    actions = [],
    children,
    downloadController,
    downloadData = [],
    downloadHeaders,
    downloadName,
    externalLogin,
    filterLabel,
    filterOptions = [],
    footer,
    loading,
    onAction = () => null,
    onFilterChange,
    searchBar = true
}) => {

    const { t } = useTranslation();

    const [state, , setValue] = useObjectState({
        filter: null,
        search: ''
    });
    const [externalLoginModal, setExternalLoginModal] = useState(false);

    const downloadable = !isEmpty(downloadController);
    const { search } = state;

    const handleChange = (input, value) => {
        setValue(input, value);
        if (input === 'filter') {
            onFilterChange && onFilterChange({ filter: value, search });
        }
    };

    const handleSubmit = keyCode => {
        if (keyCode === 13) {
            onFilterChange && onFilterChange(state);
        }
    };

    return (
        <Container>
            <ExternalLoginModal
                active={ externalLoginModal }
                profile="professional"
                onToggle={ () => setExternalLoginModal(false) }
            />
            {
                searchBar &&
                <FilterBox>
                    <Search>
                        <MaterialIcon color={ textColor } icon="search" size={ 30 } />
                        <Input
                            disabled={ loading }
                            placeholder={ `${ t('Buscar') }...` }
                            value={ search }
                            onChange={ e => handleChange('search', e.currentTarget.value) }
                            onKeyUp={ e => handleSubmit(e.keyCode) }
                        />
                    </Search>
                    {
                        !isEmpty(filterOptions) &&
                        <Dropdown
                            fontSize="12px"
                            options={ filterOptions.map(({ label, value }) => ({
                                label,
                                onClick: () => handleChange('filter', value)
                            })) }
                            text={ filterLabel ?? t('Filtrar') }
                            top="6px"
                        />
                    }
                    {
                        actions.map(({ action, label }, index) => (
                            <DownloadBox key={ index } onClick={ () => onAction(action) }>
                                { label }
                            </DownloadBox>
                        ))
                    }
                    {
                        downloadData.length > 0 &&
                        <DownloadBox searchBar={ searchBar }>
                            <CSVLink
                                className="download-button"
                                data={ downloadData }
                                filename={ `${ downloadName ? downloadName : t('Listado') }.csv` }
                                headers={ downloadHeaders }
                                separator=";"
                                target="_blank">
                                { t('Exportar listado') }
                            </CSVLink>
                        </DownloadBox>
                    }
                    {
                        externalLogin &&
                        <IconButton
                            icon="login"
                            label={ t('Login externo') }
                            margin="0px 0px 3px 0px"
                            size={ 15 }
                            onClick={ () => setExternalLoginModal(true) }
                        />
                    }
                </FilterBox>
            }
            {
                downloadable &&
                <DownloadList
                    downloadController={ downloadController }
                />
            }
            <List footer={ !!footer } searchBar={ !!searchBar }>
                {
                    !loading
                        ? children
                        : <Loader active={ !!loading } />
                }
            </List>
            {
                !!footer &&
                <FooterContainer>
                    { footer }
                </FooterContainer>
            }
        </Container>
    );
};

ListingLayout.propTypes = {
    actions: PropTypes.array,
    children: PropTypes.any,
    downloadController: PropTypes.object,
    downloadData: PropTypes.array,
    downloadHeaders: PropTypes.array,
    downloadName: PropTypes.string,
    externalLogin: PropTypes.bool,
    filterLabel: PropTypes.string,
    filterOptions: PropTypes.array,
    footer: PropTypes.any,
    loading: PropTypes.bool,
    onAction: PropTypes.func,
    onFilterChange: PropTypes.func,
    searchBar: PropTypes.bool
};

export default ListingLayout;
